const axios = require("axios");
const XLSX = require("xlsx");

const API_URL = process.env.VUE_APP_API_URL;

// Funzione per ottenere le località nel raggio
async function fetchLocalitaNelRaggio(center, radiusKm, minPopulation) {
  // Verifica se center è un array e contiene due valori
  if (!Array.isArray(center) || center.length !== 2) {
    throw new Error("center deve essere un array con [lat, lon]");
  }

  const [lat, lon] = center; // De-strutturazione delle coordinate
  const overpassUrl = `https://overpass.kumi.systems/api/interpreter?data=[out:json];node[place](around:${
    radiusKm * 1000
  },${lat},${lon});out;`;

  try {
    const response = await axios.get(overpassUrl);
    const data = response.data;

    return data.elements
      .map((element) => ({
        nome: element.tags.name || "Sconosciuto",
        lat: element.lat,
        lon: element.lon,
        distanza: calculateDistance(lat, lon, element.lat, element.lon),
        popolazione: element.tags.population || "Sconosciuta",
      }))
      .filter(
        (loc) =>
          loc.distanza <= radiusKm &&
          (loc.popolazione !== "Sconosciuta" ||
            parseInt(loc.popolazione) >= minPopulation)
      );
  } catch (error) {
    console.error("Errore nella richiesta Overpass:", error); // Log dell'errore
    throw error; // Rilancia l'errore per essere catturato nel controller
  }
}

// Funzione per generare un file Excel
function generateExcel(aziendaData, localitaData, localitaSelezionateData, aziendeTrovateData) {
  const wb = XLSX.utils.book_new();

  // Creazione dei fogli
  const aziendaSheet = XLSX.utils.json_to_sheet(aziendaData);
  const localitaSheet = XLSX.utils.json_to_sheet(localitaData);
  const localitaSelezionateSheet = XLSX.utils.json_to_sheet(
    localitaSelezionateData
  );
  const aziendeTrovateSheet = XLSX.utils.json_to_sheet(aziendeTrovateData);

  // Aggiunta dei fogli al workbook
  XLSX.utils.book_append_sheet(wb, aziendaSheet, "Dati Azienda");
  XLSX.utils.book_append_sheet(wb, localitaSheet, "Località Trovate");
  XLSX.utils.book_append_sheet(
    wb,
    localitaSelezionateSheet,
    "Località Selezionate"
  );
  XLSX.utils.book_append_sheet(wb, aziendeTrovateSheet, "Aziende Cercate");

  // Generazione del buffer Excel
  return XLSX.write(wb, { type: "buffer", bookType: "xlsx" });
}

// Funzione per calcolare la distanza tra due coordinate
function calculateDistance(lat1, lon1, lat2, lon2) {
  const R = 6371; // Raggio della Terra in km
  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLon = ((lon2 - lon1) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos((lat1 * Math.PI) / 180) *
      Math.cos((lat2 * Math.PI) / 180) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c; // Distanza in km
}

async function loadAtecoList(authStore) {
  try {
    let atecoList = authStore.user.atecoList; //sessionStorage.getItem("atecoList");

    // Se atecoList è null o undefined, inizializza come array vuoto
    if (!atecoList) {
      atecoList = [];
    } else if (typeof atecoList === "string") {
      atecoList = JSON.parse(atecoList);
    }

    const response = await axios.post(
      `${API_URL}/api/ateco/`, // Usa l'URL dinamico
      { primoLivello: false, atecoList: atecoList },
      {
        headers: {
          Authorization: `Bearer ${authStore.token}`,
        },
      }
    );

    // Verifica che response.data e response.data.list siano definiti
    if (!response.data || !response.data.list) {
      throw new Error(
        "La risposta dell'API non contiene i dati attesi (list mancante)"
      );
    }

    // Ritorna la lista degli ATECO
    return response.data.list || [];
  } catch (error) {
    // Log dettagliato per errori di risposta
    if (error.response) {
      console.error("Dettagli errore API:", error.response.data);
    }

    throw error;
  }
}

async function searchAzienda(authStore, selectedAtecoCodes, provincia) {
  try {
    if (!authStore.token) {
      throw new Error("Autenticazione fallita: token non fornito");
    }

    if (!Array.isArray(selectedAtecoCodes)) {
      selectedAtecoCodes = [selectedAtecoCodes];
    }

    if (!provincia || typeof provincia !== "string" || provincia.trim() === "") {
      throw new Error("Parametro 'provincia' obbligatorio e non valido");
    }

    const response = await axios.post(
      `${API_URL}/api/list`,
      {
        prv: provincia,
        atecoList: selectedAtecoCodes,
      },
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${authStore.token}`,
        },
      }
    );

    if (response.status !== 200) {
      throw new Error(`Errore API: ${response.status} ${response.statusText}`);
    }

    if (response.status === 401) {
      throw new Error("Errore di autorizzazione, effettual la logout e riprova!");
    }
    const data = response.data;
    if (!data.lista || !Array.isArray(data.lista) || data.lista.length === 0) {
      throw new Error("Nessuna azienda trovata per gli ATECO selezionati.");
    }

    data.lista.forEach((item) => {
      item.INSEGNE = Array.isArray(item.LISTA_INSEGNE)
        ? item.LISTA_INSEGNE.join(", ")
        : "N/A";
      item.TELEFONO = Array.isArray(item.LISTA_NUMERI_TEL)
        ? item.LISTA_NUMERI_TEL.join(", ")
        : "N/A";
      item.EMAIL = Array.isArray(item.LISTA_MAIL)
        ? item.LISTA_MAIL.join(", ")
        : "N/A";
      item.WEB = Array.isArray(item.LISTA_SITI_WEB)
        ? item.LISTA_SITI_WEB.join(", ")
        : "N/A";  
      item.CATEGORIA = `${item.DESCRIZIONE}`;
      item.VIA_DENOMINAZIONE = item.DENOMINAZIONE || "N/A";
      item.NUMERO_CIVICO = item.NUMERO_CIVICO || "";
    });

    return data.lista;
  } catch (error) {
    console.error("Errore nel caricamento degli ATECO:", error);
    throw new Error(error);
  }
}

module.exports = {
  fetchLocalitaNelRaggio,
  generateExcel,
  loadAtecoList,
  searchAzienda,
};
